import { render, staticRenderFns } from "./withholding-payment.vue?vue&type=template&id=731cbaea&scoped=true&"
import script from "./withholding-payment.vue?vue&type=script&lang=js&"
export * from "./withholding-payment.vue?vue&type=script&lang=js&"
import style0 from "./withholding-payment.vue?vue&type=style&index=0&id=731cbaea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731cbaea",
  null
  
)

export default component.exports